/** Categoría Academy para el manual de publicación de noticias TNO en Ghost. */
export const WIKI_PUBLICAR_NOTICIAS_TNO_CATEGORY = 'wiki-publicar-noticias-tno';

export const WIKI_PUBLICAR_NOTICIAS_TNO_HERO_SLUG = 'wiki-noticias-hero';

/** Cuerpo único del manual (HTML en una sola knowledge page). */
export const WIKI_PUBLICAR_NOTICIAS_TNO_BODY_SLUG = 'wiki-noticias-manual-completo';
